export default __webpack_public_path__ + "static/media/slide15.32059f7e.webp";